import { Component, inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';

export interface TemplateConfirmDialogData {
  // Replace-or-append is only a question for a field that already has text.
  fieldHasContent: boolean;
  // Extra field-specific instructions, highlighted below the standard text.
  // Rendered as HTML so a note can carry an inline link; the notes are app
  // constants, never user input, and Angular sanitizes the markup anyway.
  note?: string;
}

@Component({
  selector: 'app-template-confirm-dialog',
  imports: [MatButton, MatCheckbox, MatDialogActions, MatDialogContent, MatIcon],
  templateUrl: './template-confirm-dialog.html',
})
export class TemplateConfirmDialog {
  readonly dialogRef = inject(MatDialogRef<TemplateConfirmDialog>);

  readonly data = inject<TemplateConfirmDialogData>(MAT_DIALOG_DATA);

  // Off by default: appending is the safe choice, replacing throws work away.
  readonly replace = signal(false);
}
